<template>
  <b-card class="kpi-card" :class="`border-${statusVariant}`" no-body>
    <div class="kpi-card-header" @click="toggleExpand">
      <b-avatar :variant="`light-${statusVariant}`" size="32" class="kpi-icon">
        <feather-icon :icon="statusIcon" size="16" />
      </b-avatar>
      <span class="kpi-value" :class="`text-${statusVariant}`">{{ formattedValue }}</span>
      <span class="kpi-title">{{ title }}</span>
      <div class="kpi-card-header-right ml-auto">
        <b-badge v-if="statusLabel" :variant="`light-${statusVariant}`" class="kpi-status-badge">
          {{ statusLabel }}
        </b-badge>
        <feather-icon
          v-if="drilldownEnabled"
          :icon="isExpanded ? 'ChevronUpIcon' : 'ChevronDownIcon'"
          size="16"
          class="kpi-toggle-icon"
        />
      </div>
    </div>

    <b-collapse v-model="isExpanded">
      <div class="kpi-detail">
        <p v-if="target !== null" class="text-muted small mb-50">
          Objetivo: {{ target }}{{ unit === '%' ? '%' : '' }}
        </p>
        <kpi-drilldown-table :items="items" :fields="fields" />
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import { BCard, BBadge, BAvatar, BCollapse } from 'bootstrap-vue'
import KpiDrilldownTable from './KpiDrilldownTable.vue'

export default {
  name: 'KPICard',
  components: { BCard, BBadge, BAvatar, BCollapse, KpiDrilldownTable },
  props: {
    title: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    target: { type: Number, default: null },
    status: { type: String, default: 'info' }, // ok, warning, critical, info
    unit: { type: String, default: '' }, // %, #, ''
    drilldownEnabled: { type: Boolean, default: true },
    items: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    expanded: { type: Boolean, default: false },
  },
  computed: {
    isExpanded: {
      get() {
        return this.expanded
      },
      set(value) {
        this.$emit('update:expanded', value)
      },
    },
    formattedValue() {
      if (this.unit === '%') return `${this.value}%`
      return this.value
    },
    statusVariant() {
      const map = { ok: 'success', warning: 'warning', critical: 'danger', info: 'info' }
      return map[this.status] || 'info'
    },
    statusIcon() {
      const map = { ok: 'CheckCircleIcon', warning: 'AlertCircleIcon', critical: 'AlertTriangleIcon', info: 'InfoIcon' }
      return map[this.status] || 'InfoIcon'
    },
    statusLabel() {
      const map = { ok: 'OK', warning: 'ATENCIÓN', critical: 'CRÍTICO' }
      return map[this.status] || null
    },
  },
  methods: {
    toggleExpand() {
      if (this.drilldownEnabled) this.isExpanded = !this.isExpanded
    },
  },
}
</script>

<style lang="scss" scoped>
.kpi-card {
  border-left-width: 3px !important;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
}

.kpi-card-header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 1rem;
  cursor: pointer;
}

.kpi-icon {
  flex-shrink: 0;
}

.kpi-value {
  font-size: 1.4rem;
  font-weight: 700;
  white-space: nowrap;
}

.kpi-title {
  font-size: 0.8rem;
  font-weight: 500;
  color: #6e6b7b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kpi-card-header-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.kpi-status-badge {
  flex-shrink: 0;
  font-size: 0.65rem;
}

.kpi-toggle-icon {
  flex-shrink: 0;
  color: #6e6b7b;
}

.kpi-detail {
  padding: 0 1rem 0.75rem;
  border-top: 1px solid #ebe9f1;
  padding-top: 0.75rem;
}
</style>
